import { SingletonRouter } from "next/router";

import { Orientation, CardOrientationQueryParam, CardOrientationDefault } from "./constants";
import { RouteParams } from "./types";

type AddOrientationParam = (
  orientation: Orientation,
  router?: SingletonRouter<RouteParams>
) => string;
export const addOrientationParam: AddOrientationParam = (orientation, router) => {
  const pathname = router && router.asPath ? router.asPath : "";
  const newUrl = new URL(pathname, "https://dummy");
  if (orientation === CardOrientationDefault) {
    newUrl.searchParams.delete(CardOrientationQueryParam);
  } else {
    newUrl.searchParams.set(CardOrientationQueryParam, orientation);
  }
  return `${newUrl.pathname}${newUrl.search}`;
};
